function isTokenExpired(exp: number | string | null | undefined) {
  return !exp || Date.now() > Number(exp) * 1000;
}

export { isTokenExpired };
